import React, { useState, useEffect, useRef } from 'react'
import Navbar from '../../Navbar'
import {Chip, InputAdornment, Paper, TextField, Typography, Autocomplete, Grid, Box, alpha, Select, FormControl, MenuItem, InputLabel } from '@mui/material';

import * as apiIngresoRemitos from "./../api"
import * as apiVtasFact from "../../ventas/facturacion/api"
import InputMask from "react-input-mask";
import PersonIcon from "@mui/icons-material/Person"
import LocationOnIcon from "@mui/icons-material/LocationOn"
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined"
import EventOutlinedIcon from "@mui/icons-material/EventOutlined"
import WarehouseOutlinedIcon from "@mui/icons-material/WarehouseOutlined"
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined"
import SectionHeader from "./SectionHeader"
import StorefrontIcon from '@mui/icons-material/Storefront';
import Person4Icon from '@mui/icons-material/Person4';
import {hasFullAccess} from "../../../utils/filters"

function FormDatosRemitos({
    almacenar,
    dataRemito,
    setDataRemito,
    clientes,
    setClientes,
    clienteSeleccionado,
    setClienteSeleccionado,
    direccionSeleccionada,
    setDireccionSeleccionada,
    direcciones,
    setDirecciones,
    sucursales,
    setSucursales,
    choferes,
    setChoferes,
    empresas,
    buscaRepeticion
}) {
    const [cargando, setCargando] = useState();
    const [noOptionsTextClientes, setNoOptionsTextClientes] = useState("Tipee para buscar clientes...")
    const sucAuth = localStorage.getItem("suc_auth")
    const timeoutRef = useRef(null);
    const isControlador = Boolean(Number(localStorage.getItem("controlador")))
    const userSucData = {id: localStorage.getItem("sucursal")}

    const getOptionDisabled = (option) => {
        if(isControlador) return false;

        const fullAccess = hasFullAccess();
        if (fullAccess) return false;

        const matchSucUserCliente = (userSucData.id == clienteSeleccionado.id_sucursal) || (userSucData.id_alias == clienteSeleccionado.id_sucursal);
        if (matchSucUserCliente) return false;

        if ((userSucData.id == option?.id_sucursal) || (userSucData.id_alias == option?.id_sucursal)) return false;

        return true;
    }

    return (
        <div>
            <Paper
                elevation={0}
                sx={{
                    border: "1px solid",
                    borderColor: "divider",
                    borderRadius: 3,
                    overflow: "hidden",
                }}
            >
                <SectionHeader
                    icon={<BadgeOutlinedIcon fontSize="small" />}
                    title="Datos del remito."
                    subtitle="Identificación del remito, cliente y destino de entrega"
                />
                <Box sx={{ p: { xs: 2, md: 3 } }}>
                    <Grid container spacing={1.5}>
                        <Grid item xs={12} sm={12} md={12}>
                            <FormControl
                                size="small"
                                fullWidth
                                name="id_empresa"
                            >
                                <InputLabel>Empresa</InputLabel>
                                <Select
                                    name="id_empresa"
                                    value={dataRemito.id_empresa}
                                    onChange={almacenar}
                                    label="Empresa"
                                >
                                    {empresas?.map((suc) => (
                                        <MenuItem
                                            key={suc.idempresa}
                                            value={suc.idempresa}
                                        >
                                            {suc.empresa}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3} lg={3} container spacing={0.5}>
                            <Grid item xs={4}>
                                <TextField
                                    size="small"
                                    fullWidth
                                    type="text"
                                    label="P. Venta"
                                    name="puntoVenta"
                                    value={dataRemito.puntoVenta || ''}
                                    onChange={(e) => {
                                        const val = e.target.value.replace(/\D/g, '').slice(0, 4);
                                        almacenar({ target: { name: 'puntoVenta', value: val } });
                                    }}
                                    onBlur={(e) => {
                                        if (e.target.value) {
                                            const padded = e.target.value.padStart(4, '0');
                                            almacenar({ target: { name: 'puntoVenta', value: padded } });
                                            // console.log(dataRemito.puntoVenta, padded);
                                            buscaRepeticion(dataRemito, padded);
                                        }
                                    }}
                                    inputProps={{ maxLength: 4, inputMode: 'numeric' }}

                                />
                            </Grid>
                                    
                            <Grid item xs={8}>
                                <TextField
                                    size="small"
                                    fullWidth
                                    type="text"
                                    label="Nro. Remito"
                                    name="nroComprobante"
                                    value={dataRemito.nroComprobante || ''}
                                    onChange={(e) => {
                                        const val = e.target.value.replace(/\D/g, '').slice(0, 8);
                                        almacenar({ target: { name: 'nroComprobante', value: val } });
                                    }}
                                    onBlur={(e) => {
                                        if (e.target.value) {
                                            const padded = e.target.value.padStart(8, '0');
                                            almacenar({ target: { name: 'nroComprobante', value: padded } });
                                            buscaRepeticion(dataRemito, padded);

                                        }
                                    }}
                                    inputProps={{ maxLength: 8, inputMode: 'numeric' }}
                                />
                            </Grid>
                        </Grid>

                        <Grid item xs={12} md={4.5}>
                            <Autocomplete
                                disabled={!dataRemito.id_empresa}
                                size="small"
                                disableClearable
                                placeholder="Nombre, CUIT o Sisven ID"
                                options={clientes}
                                loading={cargando}
                                value={clienteSeleccionado || null} 
                                onChange={(e, value) => {
                                    setClienteSeleccionado(value);
                                    setDirecciones([]);
                                    setDireccionSeleccionada(null);
                                }}
                                noOptionsText={noOptionsTextClientes}
                                onInputChange={(e, value, reason) => {
                                    if (reason === 'input') {
                                        setClienteSeleccionado(null);

                                        if (timeoutRef.current) {
                                            clearTimeout(timeoutRef.current);
                                            timeoutRef.current = null;
                                        }

                                        if (value?.length >= 2) {
                                            timeoutRef.current = setTimeout(() => {
                                                apiIngresoRemitos.fetchClientesByEmpresa(
                                                    value,
                                                    setClientes,
                                                    false,
                                                    setCargando,
                                                    setNoOptionsTextClientes,
                                                    sucAuth,
                                                    isControlador,
                                                    dataRemito.id_empresa
                                                );
                                                timeoutRef.current = null;
                                            }, 300);
                                        } else {
                                            setNoOptionsTextClientes("Tipee para buscar clientes...");
                                            setClientes([]);
                                        }
                                    }
                                }}
                                getOptionLabel={(option) => {
                                    if (!option) return "";
                                    const razonSoc = option?.razon_social?.trim() || "";
                                    const cuit = option?.cuit?.trim()?.length > 0
                                        ? option?.cuit?.trim()?.replace(/\D/g, '')
                                        : "Cuit No Registrado";
                                    const sisvenId = option?.sisven_id || "";
                                    return `${razonSoc} (${cuit}) ${sisvenId}`.trim();
                                }}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                renderOption={(props, option) => {
                                    const { key, ...optionProps } = props;
                                  
                                    const cuit = option?.cuit?.trim()?.length > 0
                                      ? option?.cuit?.trim()?.replace(/\D/g, '')
                                      : "Cuit No Registrado";
                                  
                                    return (
                                      <Box
                                        component="li"
                                        key={key || option.id}
                                        {...optionProps}
                                        sx={{
                                          padding: "12px 16px !important",
                                          borderBottom: "1px solid #f1f5f9",
                                          transition: "all 0.2s ease",
                                          display: "flex",
                                          flexDirection: "column",
                                          alignItems: "flex-start !important",
                                          gap: "4px",
                                          "&:hover": {
                                            backgroundColor: "#f8fafc !important",
                                          },
                                          '&[aria-selected="true"]': {
                                            backgroundColor: alpha("#164e63", 0.08) + " !important",
                                            color: "#164e63",
                                            fontWeight: 600,
                                          },
                                        }}
                                      >
                                        {/* Fila superior: Ícono + Razón Social */}
                                        <Box sx={{ display: "flex", alignItems: "center", gap: "10px", width: "100%" }}>
                                          <PersonIcon sx={{ fontSize: "20px", color: "#164e63", flexShrink: 0 }} />
                                          <Typography
                                            sx={{
                                              fontSize: "14px",
                                              fontWeight: 500,
                                              color: "#0f172a",
                                              lineHeight: 1.4
                                            }}
                                          >
                                            {option?.razon_social?.trim()}
                                          </Typography>
                                        </Box>
                                  
                                        <Box
                                          sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "12px",
                                            pl: "30px", // Alineado horizontalmente con el texto de la razón social
                                            flexWrap: "wrap"
                                          }}
                                        >
                                          <Typography sx={{ fontSize: "12px", color: "#64748b" }}>
                                            <Box component="span" sx={{ fontWeight: 600, color: "#475569" }}>CUIT:</Box> {cuit}
                                          </Typography>
                                  
                                          {option?.sisven_id && (
                                            <Typography sx={{ fontSize: "12px", color: "#64748b" }}>
                                              <Box component="span" sx={{ fontWeight: 600, color: "#475569" }}>Sisven:</Box> {option.sisven_id}
                                            </Typography>
                                          )}
                                  
                                          {option?.negocio_cliente && (
                                            <Chip
                                              label={option.negocio_cliente}
                                              size="small"
                                              sx={{
                                                height: "20px",
                                                fontSize: "11px",
                                                fontWeight: 500,
                                                backgroundColor: "#e0f2fe",
                                                color: "#0369a1",
                                                border: "1px solid #bae6fd",
                                                "& .MuiChip-label": {
                                                  px: "8px"
                                                }
                                              }}
                                            />
                                          )}
                                        </Box>
                                      </Box>
                                    );
                                  }}
                                // renderOption={(props, option) => {
                                //     const cuit = option?.cuit?.trim()?.length > 0
                                //         ? option?.cuit?.trim()?.replace(/\D/g, '')
                                //         : "Cuit No Registrado";
                                //     return (
                                //         <Box
                                //             component="li"
                                //             {...props}
                                //             key={option.id}
                                //             sx={{
                                //                 padding: "12px 16px !important",
                                //                 borderBottom: "1px solid #f1f5f9",
                                //                 transition: "all 0.2s ease",
                                //                 "&:hover": {
                                //                     backgroundColor: "#f1f5f9 !important",
                                //                 },
                                //                 '&[aria-selected="true"]': {
                                //                     backgroundColor: alpha("#164e63", 0.08) + " !important",
                                //                     color: "#164e63",
                                //                     fontWeight: 600,
                                //                 },
                                //             }}
                                //         >
                                //             <PersonIcon sx={{ fontSize: "18px", color: "#475569", mr: 1 }} />
                                //             {option?.razon_social?.trim()} ({cuit})
                                //             {option?.sisven_id && (
                                //                 <Typography
                                //                     component="span"
                                //                     sx={{
                                //                         color: "#475569",
                                //                         fontSize: "0.85rem",
                                //                         ml: 1,
                                //                     }}
                                //                 >
                                //                     - Sisven: {option?.sisven_id}
                                //                 </Typography>
                                //             )}
                                //         </Box>
                                //     );
                                // }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Cliente"
                                        variant="outlined"
                                        placeholder="Buscar cliente..."
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} md={4.5}>
                            <Autocomplete
                                size="small"
                                disabled={!clienteSeleccionado}
                                disableClearable
                                placeholder="Dirección"
                                options={direcciones || []}
                                value={direccionSeleccionada || null}
                                onChange={(e, value) => {
                                    setDireccionSeleccionada(value);
                                    if (value?.id) {
                                        almacenar({
                                            target: { name: "id_direccion_entrega", value: value.id }
                                        });
                                }
                            }}
                            getOptionDisabled={(option) => getOptionDisabled(option)}
                                noOptionsText={"No se encuentran resultados para esta búsqueda..."}
                                getOptionLabel={(option) => {
                                    if (!option) return "";
                                    const dir = option?.direccion_entrega?.trim() || "";
                                    const nombre = option?.nombre_direccion ? ` (${option.nombre_direccion.trim()})` : "";
                                    return `${dir}${nombre}`;
                                }}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                renderOption={(props, option) => (
                                    <Box
                                        component="li"
                                        {...props}
                                        key={option.id}
                                        sx={{
                                            padding: "12px 16px !important",
                                            borderBottom: "1px solid #f1f5f9",
                                            transition: "all 0.2s ease",
                                            "&:hover": {
                                                backgroundColor: "#f1f5f9 !important",
                                            },
                                            '&[aria-selected="true"]': {
                                                backgroundColor: alpha("#164e63", 0.08) + " !important",
                                                color: "#164e63",
                                                fontWeight: 600,
                                            },
                                        }}
                                    >
                                        <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                            <LocationOnIcon sx={{ fontSize: "18px", color: "#475569" }} />
                                        </Box>
                                        {option?.direccion_entrega?.trim()}{" "}
                                        {option?.nombre_direccion ? `(${option.nombre_direccion})` : ""}
                                    </Box>
                                )}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Domicilio de entrega"
                                        variant="outlined"
                                        placeholder="Buscar domicilio..."
                                        sx={{
                                            "& .MuiOutlinedInput-root": {
                                                backgroundColor: "#ffffff",
                                                transition: "all 0.3s ease",
                                                "&:hover": {
                                                    "& .MuiOutlinedInput-notchedOutline": {
                                                        borderColor: "#164e63",
                                                    },
                                                },
                                                "&.Mui-focused": {
                                                    "& .MuiOutlinedInput-notchedOutline": {
                                                        borderColor: "#164e63",
                                                        borderWidth: "2px",
                                                    },
                                                },
                                            },
                                            "& .MuiInputLabel-root": {
                                                color: "#475569",
                                                fontWeight: 500,
                                                "&.Mui-focused": {
                                                    color: "#164e63",
                                                },
                                            },
                                        }}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <TextField
                                size="small"
                                fullWidth
                                type="date"
                                name="fecha"
                                value={dataRemito.fecha}
                                label="Fecha Entrega"
                                onChange={almacenar}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <EventOutlinedIcon fontSize="small" color="action" />
                                        </InputAdornment>
                                    ),
                                }}
                                inputProps={{
                                    max: new Date().toISOString().split('T')[0]
                                }}
                            >
                            </TextField>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <Autocomplete
                                size="small"
                                disabled={!sucursales}
                                disableClearable
                                placeholder="Sucursales.."
                                options={sucursales || []}
                                value={sucursales?.find(suc => suc.id === dataRemito?.id_sucursal_remite) || null}
                                onChange={(event, newValue) => {
                                    const sucId = newValue?.id;
                                    if (sucId) {
                                        setDataRemito(prev => ({
                                            ...prev,
                                            id_sucursal_remite: sucId,
                                            id_chofer: null
                                        }));
                                        setChoferes(null);
                                        apiIngresoRemitos.getChoferes(sucId, setChoferes);
                                    }
                                }}
                                noOptionsText={"No se encuentran resultados para esta búsqueda..."}
                                getOptionLabel={(option)=> `${option.nombre}`}
                                isOptionEqualToValue={(option, value) =>
                                    option?.id === value?.id
                                }
                                renderOption={(props, option) => (
                                    <Box
                                        component="li"
                                        {...props}
                                        key={option.id}
                                        sx={{
                                            padding: "12px 16px !important",
                                            borderBottom: "1px solid #f1f5f9",
                                            transition: "all 0.2s ease",
                                            "&:hover": {
                                                backgroundColor: "#f1f5f9 !important",
                                            },
                                            '&[aria-selected="true"]': {
                                                backgroundColor: alpha("#164e63", 0.08) + " !important",
                                                color: "#164e63",
                                                fontWeight: 600,
                                            },
                                        }}
                                    >
                                        <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                            <StorefrontIcon color="primary" sx={{ fontSize: "18px"}} />
                                        </Box>
                                        {option?.nombre}
                                    </Box>
                                )}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Sucursal Remite"
                                        variant="outlined"
                                        placeholder="Buscar sucursal..."
                                        sx={{
                                            "& .MuiOutlinedInput-root": {
                                                backgroundColor: "#ffffff",
                                                transition: "all 0.3s ease",
                                                "&:hover": {
                                                    "& .MuiOutlinedInput-notchedOutline": {
                                                        borderColor: "#164e63",
                                                    },
                                                },
                                                "&.Mui-focused": {
                                                    "& .MuiOutlinedInput-notchedOutline": {
                                                        borderColor: "#164e63",
                                                        borderWidth: "2px",
                                                    },
                                                },
                                            },
                                            "& .MuiInputLabel-root": {
                                                color: "#475569",
                                                fontWeight: 500,
                                                "&.Mui-focused": {
                                                    color: "#164e63",
                                                },
                                            },
                                        }}
                                        InputProps={{
                                            ...params.InputProps,
                                        }}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <Autocomplete
                                size="small"
                                disabled={!choferes}
                                disableClearable
                                placeholder="Chofer.."
                                options={choferes || []}
                                value={choferes?.find(ch => ch.id === dataRemito?.id_chofer) || null}
                                onChange={(event, newValue) => {
                                    const chofId = newValue.id
                                    if (chofId) {
                                        almacenar({
                                            target: { name: "id_chofer", value: chofId }
                                        });
                                    }
                                }}
                                noOptionsText={"No se encuentran resultados para esta búsqueda..."}
                                getOptionLabel={(option)=> `${option.nombre_apellido}`}
                                isOptionEqualToValue={(option, value) =>
                                    option?.id === value?.id
                                }
                                renderOption={(props, option) => (
                                    <Box
                                        component="li"
                                        {...props}
                                        key={option.id}
                                        sx={{
                                            padding: "12px 16px !important",
                                            borderBottom: "1px solid #f1f5f9",
                                            transition: "all 0.2s ease",
                                            "&:hover": {
                                                backgroundColor: "#f1f5f9 !important",
                                            },
                                            '&[aria-selected="true"]': {
                                                backgroundColor: alpha("#164e63", 0.08) + " !important",
                                                color: "#164e63",
                                                fontWeight: 600,
                                            },
                                        }}
                                    >
                                        <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                            <Person4Icon color="warning" sx={{ fontSize: "18px"}} />
                                        </Box>
                                        {option?.nombre_apellido}
                                    </Box>
                                )}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Chofer"
                                        variant="outlined"
                                        placeholder="Buscar chofer..."
                                        sx={{
                                            "& .MuiOutlinedInput-root": {
                                                backgroundColor: "#ffffff",
                                                transition: "all 0.3s ease",
                                                "&:hover": {
                                                    "& .MuiOutlinedInput-notchedOutline": {
                                                        borderColor: "#164e63",
                                                    },
                                                },
                                                "&.Mui-focused": {
                                                    "& .MuiOutlinedInput-notchedOutline": {
                                                        borderColor: "#164e63",
                                                        borderWidth: "2px",
                                                    },
                                                },
                                            },
                                            "& .MuiInputLabel-root": {
                                                color: "#475569",
                                                fontWeight: 500,
                                                "&.Mui-focused": {
                                                    color: "#164e63",
                                                },
                                            },
                                        }}
                                        InputProps={{
                                            ...params.InputProps,
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>
                </Box>
            </Paper>
        </div>
    )
}

export default FormDatosRemitos

  {/* <FormControl
        size="small"
        fullWidth
        name="id_sucursal_remite"
    >
        <InputLabel>Sucursal Remite</InputLabel>
        <Select
            name="id_sucursal_remite"
            value={dataRemito.id_sucursal_remite}
            onChange={(e)=>{
                almacenar(e)
                apiIngresoRemitos.getChoferes(e.target.value, setChoferes)
            }}
            label="Sucursal Remite"
        >
            {sucursales?.map((suc) => (
                <MenuItem
                    key={suc.id}
                    value={suc.id}
                >
                    {suc.nombre}
                </MenuItem>
            ))}
        </Select>
    </FormControl> */}

    {/* <FormControl
        fullWidth
        size="small"
    >
        <InputLabel>Chofer/Vendedor</InputLabel>
        <Select
            name="id_chofer"
            value={dataRemito.id_chofer}
            onChange={almacenar}
            label="Chofer/Vendedor"
            startAdornment={
                <InputAdornment position="start">
                    <LocalShippingOutlinedIcon fontSize="small" color="action" />
                </InputAdornment>
            }
        >
            {choferes?.map((chofer) => (
                <MenuItem
                    key={chofer.id}
                    value={chofer.id}
                >
                    {chofer.nombre_apellido}
                </MenuItem>
            ))}
        </Select>
    </FormControl> */}